import React from "react";
import { useTranslation } from "react-i18next";
import {
  Typography,
  Box,
  IconButton,
  Divider,
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import Header from "./Header";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailIcon from "@mui/icons-material/Email";
import BusinessIcon from "@mui/icons-material/Business";
import PhoneIcon from "@mui/icons-material/Phone";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
  mapContainer: {
    marginTop: theme.spacing(3),
    width: "100%",
    height: "450px",
    borderRadius: theme.spacing(1),
    overflow: "hidden",
  },
  contactText: {
    marginBottom: theme.spacing(3),
  },
  messengerButton: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  facebookIcon: {
    marginRight: theme.spacing(1),
    color: "#3b5998",
  },
  instagramIcon: {
    color: "#E1306C",
  },
  emailIcon: {
    color: "#D44638",
  },
  phoneIcon: {
    color: "#25D366",
  },
  addressIcon: {
    color: "#000000",
  },
  facebookLink: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.primary,
    textDecoration: "none",
  },
  text: {
    color: theme.palette.text.primary,
  },
  scheduleTable: {
    marginTop: theme.spacing(3),
  },
}));

const Contact = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography
        variant="h3"
        className={classes.contactText}
        style={{
          fontWeight: "bold",
          marginBottom: 20,
          textAlign: "start",
        }}
      >
        {t("pages.contact.intro_message")}
      </Typography>
      <Grid container spacing={3} mt={2}>
        <Grid item xs={12} md={12} sm={12}>
          <Header title="Contact" />
          <Typography variant="h3" className={classes.contactText}>
            {t("pages.contact.map")}
          </Typography>
          <Divider
            style={{
              marginTop: 20,
            }}
          />
          <Box className={classes.mapContainer}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3025.3734278805973!2d22.95177557742687!3d40.687772671397425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a8373801f06473%3A0x5a055206a8107f5f!2zzprOv8-Ezr_Os8-Jzr3Ouc6sIM6Vz4XOus6xz4HPgM6vzrHPgg!5e0!3m2!1sel!2sgr!4v1688555975615!5m2!1sel!2sgr"
              width="100%"
              height="100%"
              loading="lazy"
              title="Google Map"
            ></iframe>
          </Box>
        </Grid>
        <Grid item xs={12} md={12} sm={12} mt={2}>
          <Typography variant="h3" className={classes.contactText}>
            {t("pages.contact.title")}
          </Typography>

          <Divider
            style={{
              marginTop: 20,
            }}
          />
          <Box className={classes.messengerButton} mt={2}>
            <IconButton
              href="https://m.me/your-page-id"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon
                className={classes.facebookIcon}
                style={{
                  fontSize: 80,
                }}
              />
            </IconButton>

            <Typography variant="h4">
              <a
                href="https://www.facebook.com/people/Κοτογωνιά-Ευκαρπίας/100094328742187/"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.facebookLink}
              >
                <Typography variant="h4">
                  {t("pages.contact.messenger")}{" "}
                </Typography>
                &nbsp; Facebook
              </a>
            </Typography>
          </Box>
          <Box className={classes.messengerButton} mt={2}>
            <IconButton
              href="https://m.me/your-page-id"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon
                className={classes.instagramIcon}
                style={{
                  fontSize: 80,
                }}
              />
            </IconButton>

            <Typography variant="h4">
              <a
                href="https://www.facebook.com/people/Κοτογωνιά-Ευκαρπίας/100094328742187/"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.facebookLink}
              >
                <Typography variant="h4">
                  {t("pages.contact.messenger")}
                </Typography>
                &nbsp; Instagram
              </a>
            </Typography>
          </Box>

          <Box className={classes.messengerButton} mt={2}>
            <IconButton
              href="https://m.me/your-page-id"
              target="_blank"
              rel="noopener noreferrer"
            >
              <EmailIcon
                className={classes.emailIcon}
                style={{
                  fontSize: 80,
                }}
              />
            </IconButton>

            <Typography variant="h4">
              <a
                href="mailto:kotogoniaeukarpias@gmail.com"
                rel="noopener noreferrer"
                className={classes.facebookLink}
              >
                <Typography variant="h4">
                  {t("pages.contact.messenger")}{" "}
                </Typography>
                &nbsp; Email
              </a>
            </Typography>
          </Box>

          <Box className={classes.messengerButton} mt={2}>
            <IconButton aria-label="phone" color="primary">
              <PhoneIcon
                className={classes.phoneIcon}
                style={{
                  fontSize: 80,
                }}
              />
            </IconButton>

            <Typography variant="h4">
              <a
                href="tel:2310681694"
                className={classes.text}
                style={{
                  textDecoration: "none",
                }}
              >
                <Typography variant="h4">{t("pages.contact.phone")}</Typography>
                2310 68 1694
              </a>
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Box mt={2}>
        <Typography variant="h3" className={classes.contactText}>
          {t("pages.contact.working_hours")}
        </Typography>
        <Divider
          style={{
            marginTop: 20,
          }}
        />
        <Box display="flex" alignItems="center" mt={2}>
          <Typography variant="h5" className={classes.contactText}>
            {t("pages.contact.monday")}:
          </Typography>
          <Typography variant="h5" className={classes.contactText} ml={1}>
            9:00 π.μ.–3:00 μ.μ.
          </Typography>
        </Box>
        <Box display="flex" alignItems="center">
          <Typography variant="h5" className={classes.contactText}>
            {t("pages.contact.tuesday")}:
          </Typography>
          <Typography variant="h5" className={classes.contactText} ml={1}>
            9:00 π.μ.–3:00 μ.μ., 5:00–9:00 μ.μ.
          </Typography>
        </Box>
        <Box display="flex" alignItems="center">
          <Typography variant="h5" className={classes.contactText}>
            {t("pages.contact.wednesday")}:
          </Typography>
          <Typography variant="h5" className={classes.contactText} ml={1}>
            9:00 π.μ.–3:00 μ.μ.
          </Typography>
        </Box>
        <Box display="flex" alignItems="center">
          <Typography variant="h5" className={classes.contactText}>
            {t("pages.contact.thursday")}:
          </Typography>
          <Typography variant="h5" className={classes.contactText} ml={1}>
            9:00 π.μ.–3:00 μ.μ., 5:00–9:00 μ.μ.
          </Typography>
        </Box>
        <Box display="flex" alignItems="center">
          <Typography variant="h5" className={classes.contactText}>
            {t("pages.contact.friday")}:
          </Typography>
          <Typography variant="h5" className={classes.contactText} ml={1}>
            9:00 π.μ.–3:00 μ.μ., 5:00–9:00 μ.μ.
          </Typography>
        </Box>
        <Box display="flex" alignItems="center">
          <Typography variant="h5" className={classes.contactText}>
            {t("pages.contact.saturday")}:
          </Typography>
          <Typography variant="h5" className={classes.contactText} ml={1}>
            9:00 π.μ.–6:00 μ.μ.
          </Typography>
        </Box>
        <Box display="flex" alignItems="center">
          <Typography variant="h5" className={classes.contactText}>
            {t("pages.contact.sunday")}:
          </Typography>
          <Typography variant="h5" className={classes.contactText} ml={1}>
            {t("pages.contact.closed")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Contact;
